import DetectGeo from '../MapServiceStation/Core/Events/DetectGeo';
import loadGoogleMapsApi from '../GoogleMapApi'

export default (selector = 'Map-Contact',coords,that) => {

  return loadGoogleMapsApi().then(function (google) {

      const markers = new Array();
      const myLatlng = new google.LatLng(coords.lat, coords.lng);
      const mapOptions = {
        zoom: 10,
        center: myLatlng,
        mapTypeId: google.MapTypeId.ROADMAP,
        //disableDefaultUI: true,
      };

      const map = new google.Map(document.getElementById(selector), mapOptions);

      ( new DetectGeo(google,map));

      return {google,map,that};


  }).catch(function (error) {
    console.error(error)
  })

  require('../../../css/mapServiceStation.css');
}
